import Crud from '../components/Branch/Crud.vue'
import Add from '../components/Branch/Add.vue'
import Edit from '../components/Branch/Edit.vue'


let routes = {
    path: '/branches',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/branches',
            name: 'Unidades',
            component: Crud
        },
        {
            path: '/branches/add',
            name: 'Nova Unidade',
            component: Add
        },
        {
            path: '/branches/edit/:id',
            name: 'Editar Unidade',
            component: Edit
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/branch.js